import { useQuery } from '@tanstack/react-query'
import { ProjectService } from 'src/services/project.service'

const useAmslerGridImage = (
  variableId: string | number,
  patientFormId: string | number,
  patientId: string | number,
  projectId: string | number,
) => {
  const { isLoading, isError, error, data } = useQuery({
    queryKey: ['amsler-image', variableId, patientFormId, patientId, projectId],
    queryFn: () => ProjectService.getAmslerGridImage(variableId, patientFormId, patientId, projectId),
  })

  return { isLoading, isError, error, image: data?.data.dataUri }
}

export { useAmslerGridImage }
